import ClienteList from './ClienteList.vue'

export default ClienteList
